<template>
    <div class="passReset bindPhoneNum">
        <div class="pWLeft">
            <el-form :model="passSetForm" ref="passSetForm" :rules="rules">
                <el-form-item
                    label="账号："
                    >
                    <span style="margin-left:20px;">
                        {{$store.state.currentUser != null ? ($store.state.currentUser.uid ? $store.state.currentUser.uid : null) : null}}
                    </span>
                </el-form-item>
                <el-form-item
                    label="手机号码："
                    prop="phoneNum"
                    >
                    <el-col :span="8" style="width: 88px; margin-right: 10px;">
                        <el-input v-model="areaCode" size="medium" style="width: 88px;"></el-input>
                    </el-col>
                    <el-col :span="16" style="flex: 1;">
                        <el-input size="medium" placeholder="请输入手机号码" v-model="passSetForm.phoneNum" auto-complete="off"></el-input>
                    </el-col>
                </el-form-item>
                <el-form-item
                    label="短信验证码："
                    prop="checkCode"
                    >
                    <el-input size="medium" placeholder="请输入验证码" v-model="passSetForm.checkCode" auto-complete="off"></el-input>
                    <el-button size="medium" @click="sendCode" :disabled="sendBtn">{{sendText}}</el-button>
                </el-form-item>
                <div class="resetFooter">
                    <el-button type="primary" size="medium" @click="submitForm('passSetForm')" style="width:100%;">确定</el-button>
                    <el-button type="text" size="medium" @click="resetForm('passSetForm')" style="position:absolute; right:-40px; top:0;color:#333;">取消</el-button>
                </div>
            </el-form>
        </div>
    </div>
</template>

<script>
import http from '../utils/httpClient'
export default {
    name: 'bindingCellPhone',
    data () {
        var validatePhoneNum = ( rule, value, callback ) => {
            var myreg = /^[1][0,1,2,3,4,5,6,7,8,9][0-9]{9}$/;
            if ( value === '' ){
                callback( new Error('请输入手机号') ); this.sendBtn = true;
            }
            else if( !myreg.test( value ) ){
                callback( new Error('请输入正确的手机号') ); this.sendBtn = true;
            }
            else {
                if ( this.passSetForm.checkCode !== '' )
                    this.$refs.passSetForm.validateField( 'checkCode' );
                callback(); this.sendBtn = false;
            }
        };
        var validateCode = ( rule, value, callback ) => {
            if ( value === '' ) {
                callback( new Error( '请输入验证码' ) );
            } else {
                // 请求获取验证码
                // if (this.passSetForm.phoneNum != '') {
                //     if (value != 666888) {
                //         callback( new Error( '验证码错误' ) );
                //     } else {
                //         callback();
                //     }
                // }
                callback();
            }
        };
        return {
            passSetForm: {
                phoneNum: '',
                checkCode: ''
            },
            rules: {
                phoneNum: [
                    { required: true, validator: validatePhoneNum, trigger: 'blur' }
                ],
                checkCode: [
                    { required: true, validator: validateCode, trigger: 'blur' }
                ]
            },
            areaCode: '+86',
            sendBtn: true,
            sendText: '发送验证码'
        }
    },
    methods : {
        // 点击发送验证码按钮事件
        sendCode(){
            if( this.passSetForm.phoneNum != '' ){
                http.post('/mobile/verification_code',{mobile: this.passSetForm.phoneNum})
                .then(res =>{
                    if (res.head.responseCode == '0') {
                        this.$message.success('验证码发送成功！');
                    } else {
                        this.$message.error(res.head.responseMessage);
                    }
                })
                .catch(err =>{
                    this.$message.error(error);
                })

                this.sendBtn = true;
                let seconds = 60;
                this.sendText = seconds + 'S后重发';
                var timer = setInterval( () => {
                    seconds--;
                    if( seconds == 0 ){
                        this.sendBtn = false;
                        this.sendText = '发送验证码';
                        clearInterval( timer );
                        return;
                    }
                    this.sendText = seconds + 'S后重发';
                }, 1000)
            }else{
                this.sendBtn = true;
            }
        },
        // 确认按钮点击事件
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
            if (valid) {
                console.log(this.passSetForm);
                this.isDisabled = true;
                //请求绑定手机号的接口
                http.post('/people/mobile/bind',{
                    mobile: this.passSetForm.phoneNum,
                    verificationCode: this.passSetForm.checkCode
                })
                .then(res =>{
                    if (res.head.responseCode == '0') {
                        this.$message.success(res.head.responseMessage);
                        var updateObj = this.$store.state.currentUser;
                        updateObj.mobile = this.passSetForm.phoneNum;
                        this.$store.commit('saveCurrentUser',updateObj);
                        this.$router.go(-1);
                    } else {
                        this.$message.error(res.head.responseMessage);
                    }
                })
                .catch(err =>{

                })
            } else {
                // this.$message.error('error submit!');
                return false;
            }
            });
        },
        // 取消按钮点击事件
        resetForm(formName) {
            this.$refs[formName].resetFields();
            this.$router.go(-1);
        }
    }
}
</script>

<style lang="scss" scoped>
.passReset{
    display: flex; align-items: center; justify-content: center; height: 100%; font-size: 12px;
    .pWLeft{
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex-direction: column;
        min-width: 25%;
        .el-form{
            height: inherit; width: 100%; margin-top: 10px;
        }
        .resetFooter{
            position: relative; width: 100%; margin-top: 30px;
        }
    }
    .pWRight{
        float: right; margin-left: 30px;
        p{
            font-size: 12px;padding-bottom: 16px; color: #999999;
        }
    }
}
</style>
<style lang="scss">
.bindPhoneNum {
    .el-form-item__label{
        float: none; font-size: 12px; font-weight: 600; color: #2A2A2A;
    }
    .el-form-item{
        margin-bottom: 4px;
    }
    .el-form-item .el-form-item__content{
        display: flex;
    }
    .el-form-item .el-form-item__content .el-input{
        flex: 1;
    }
    .el-form-item .el-form-item__content .el-button{
        width: 84px; padding: 0; margin-left: 10px; height: 36px; margin-top: 2px;
    }
    .el-input--medium .el-input__inner{
        font-size: 12px!important;
    }
    .el-button--medium{
        font-size: 12px!important;
    }
}
</style>




// WEBPACK FOOTER //
// src/components/bindingCellPhone.vue